import { Selector } from '@ngrx/store';

import * as RouterStoreSelectors from './router.selector';

export const selectPairingCode: Selector<object, string | null> = RouterStoreSelectors.selectRouterParam('pairingCode');
